import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useOrganizationsStore = create()(
    persist(
        (set) => ({
            refetchOrganizations: false,
            storeRefetchOrganizations: (refetchOrganizations) => set(() => ({ refetchOrganizations: refetchOrganizations })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query })),

            refetchAlertReceivers: false,
            storeRefetchAlertReceivers: (refetchAlertReceivers) => set(() => ({ refetchAlertReceivers: refetchAlertReceivers })),
            alertReceivers: [],
            storeAlertReceivers: (alertReceivers) => set(() => ({ alertReceivers: alertReceivers })),

            refetchSimAlerts: false,
            storeRefetchSimAlerts: (refetchSimAlerts) => set(() => ({ refetchSimAlerts: refetchSimAlerts })),
            simAlerts: {},
            storeSimAlerts: (simAlerts) => set(() => ({ simAlerts: simAlerts })),

            refetchEnvelopesClients: false,
            storeRefetchEnvelopesClients: (refetchEnvelopesClients) => set(() => ({ refetchEnvelopesClients: refetchEnvelopesClients })),
            queryEnvelopesClients: getInitialQuery(),
            storeQueryEnvelopesClients: (queryEnvelopesClients) => set(() => ({ queryEnvelopesClients: queryEnvelopesClients }))
        }),
        {
            name: 'organizations-storage'
        }
    )
);

export default useOrganizationsStore;